var path = 'scripts/views/components/notifications.html';
var html = "<button tabindex=\"0\"\n        ng-click=\"$ctrl.onClick()\"\n        id=\"notifications-bell\"\n        class=\"button-border\"\n        aria-label=\"{{'notifications.Title' | translate}}\"\n        popover-title=\"{{'notifications.Title' | translate}}\"\n        popover-class=\"popover-notifications\">\n<i class=\"fa fa-bell cursor-pointer\"\n   aria-hidden=\"true\">\n    <span class=\"em-bold notification-font\" translate>notifications.Title</span>\n    <span class=\"badge-blue\" id=\"notifications-badge\">{{$ctrl.totalNotificationsCount}}</span>\n</i>\n</button>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/components/notifications.html
// module id = 326
// module chunks = 0